const dailycheck = {
    state: {
        active: 0,
        loadingflag: 1,
    },
    actions: {

    },
    mutations: {
        SET_PUBLIC_ACTIVE(state, value) {
            state.active = value
        },
        ALTER_LOADINGFLAG(state, value) {
            state.loadingflag = value;
        }

    },
    getters: {
        getAh(state) {
            return state.ah
        }
    },
    namespaced: true
}
export default dailycheck